import { HeatingCircuit } from 'z3k-config';
export function getClimaticBoilerHeatingCircuitsConfig(heating_circuits) {
    const shared_boiler_heating_circuit = heating_circuits.map((heating_circuit) => {
        if (!heating_circuit) {
            return null;
        }
        const { z3k_circuit } = heating_circuit;
        if (z3k_circuit && !HeatingCircuit.isEnabled(z3k_circuit)) {
            return null;
        }
        return heating_circuit;
    });
    return shared_boiler_heating_circuit;
}
